import { yupResolver } from '@hookform/resolvers/yup';
import { useSnackbar } from 'notistack';
import { useEffect, useMemo, useState } from 'react';
import { useForm } from 'react-hook-form';
import * as Yup from 'yup';

type RedeemsModalProps = {
  productHook: any;
};

export const useRedeemsModal = ({ productHook }: RedeemsModalProps) => {
  const { enqueueSnackbar } = useSnackbar();
  const defaultValues = useMemo(
    () => ({
      partner: '',
      redeem: '',
    }),
    []
  );

  const [redeemsToSet, setRedeemsToSet] = useState<{ value: string; label: string }[]>([]);

  const Schema = Yup.object().shape({
    partner: Yup.string().required('Campo obrigatório'),
    redeem: Yup.string().required('Campo obrigatório'),
  });

  const methods = useForm({
    defaultValues,
    resolver: yupResolver(Schema),
  });

  const { handleSubmit, reset, watch, setValue } = methods;

  const partner = watch('partner');

  const onSubmit = handleSubmit(async (data) => {
    const found = productHook?.allredeems?.find((redeem: any) => redeem.value === data.redeem);
    if (found) {
      productHook.setCurrentRedeem(found);
    }
    productHook.setOpenRedeemModal(false);
    enqueueSnackbar(
      'Resgatável associado com sucesso. Você pode associar os dados do resgatável ao produto nos campos com um ícone.',
      { variant: 'info', transitionDuration: 2000 }
    );
  });

  useEffect(() => {
    if (!partner) {
      productHook?.setRedeemsToSet?.([]);
      return;
    }
    setValue('redeem', '');
    const found = productHook?.allredeems?.filter(
      (redeem: any) => redeem.partnerId?._id === partner
    );
    setRedeemsToSet(
      found?.map((redeem: any) => ({
        value: redeem.value,
        label: redeem.label,
      })) || []
    );
  }, [partner, productHook.allredeems]);

  return {
    methods,
    onSubmit,
    reset,
    partner,
    redeemsToSet,
  };
};
